import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import { Arrangement } from "../arrangement/Arrangement";

/**
 * Testet die senkrechte Schiebetor-Variante (Profile vertikal).
 *
 * Diese Produktvariante existiert in den aktuellen Daten noch nicht als eigener Mass-Auswahlwert
 * (anders als Einzeltor_Easy_Senkrecht / Doppeltor_Easy_Senkrecht). Der Test ist daher
 * vorausschauend angelegt:
 *   - Fehlt der Auswahlwert `Schiebetor_Easy_Senkrecht` ODER trägt er das "Gesperrt"-Flag,
 *     gibt der Test IGNORED zurück.
 *   - Sobald die Variante existiert und freigeschaltet ist, prüft er, dass daraus ein gültiges
 *     (als Schiebetor erkanntes) Tor entsteht.
 */
export default {
  name: "TestSchiebetorSenkrecht",
};

export const testSchiebetorSenkrecht: Test = async () => {
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Schiebetor_Easy_Senkrecht");

  // Variante (noch) nicht vorhanden -> Test überspringen.
  if (!massAuswahlwert) {
    return IGNORED;
  }
  // Variante vorhanden, aber im Easyzaunplaner gesperrt -> Test überspringen.
  if ((massAuswahlwert as any).Gesperrt) {
    return IGNORED;
  }

  resetArrangement();
  const agt = APP.arrangement as Arrangement;
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.update3d();
  agt.setSelectedObjects(agt.getEmpties());
  await agt.changeSelectedZaunElemente({ massAuswahlwert });
  agt.update3d();

  const tor = agt.getTore()[0];
  // Auch die Senkrecht-Form normalisiert auf "Schiebetor" (isSchiebetorForm).
  assert.isTrue(tor.isSchiebetor, "senkrechte Variante muss als Schiebetor erkannt werden");
  assert.isNotNull(tor.schiebetorRahmenDef, "RahmenDef muss erzeugt werden");
  assert.isTrue(tor.schiebetorRahmenDef.füllungsFenster.length >= 1, "hat Füllungsfenster");
  assert.isTrue(tor.lichteWeite > 0, "lichteWeite > 0");
};
